import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { PageHeader } from '../../common';

export const StickyPageHeader = styled(PageHeader)`
  z-index: 10;
  border-bottom: 1px solid ${globalTheme.palette.secondaryAlt};
  position: sticky;
  top: 79px;

  @media (max-width: 991px) {
    top: 47px;
  }
`;
